module.exports = __webpack_public_path__ + "static/media/Security_1_inactive.698fdff7.svg";